export default __webpack_public_path__ + "static/media/JoinUs.af356bb7.gif";